"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var transfer_param_1 = require("./transfer-param");
var TransferOperation = /** @class */ (function () {
    function TransferOperation(inputs, outputs) {
        this.inputs = inputs;
        this.outputs = outputs;
    }
    TransferOperation.from = function (rawTransfer) {
        var inputs = rawTransfer.args[0].map(function (input) {
            return new transfer_param_1.default(input[0], input[1], input[3]);
        });
        var outputs = rawTransfer.args[1].map(function (input) {
            return new transfer_param_1.default(input[0], input[1], input[2]);
        });
        return new TransferOperation(inputs, outputs);
    };
    return TransferOperation;
}());
exports.default = TransferOperation;
//# sourceMappingURL=transfer-operation.js.map